var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 988.3 243.7",
    style: {
      enableBackground: "new 0 0 988.3 243.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.7115,
    y1: 19.7504,
    x2: 17.1203,
    y2: 230.3318,
    gradientTransform: "matrix(1 0 0 -1 0 246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02AABD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CDAC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.5,53.4v135.2c0,28.3,22.1,51.5,50,53.3h141.8c27.9-1.8,50-25,50-53.3V53.4c0-29-23.2-52.7-52.1-53.4H53.6 C24.7,0.7,1.5,24.4,1.5,53.4z M218,188.6c-1,24.8-22,30.2-42.9,28.3l42.9-42.6V188.6L218,188.6z M218,138.7l-77.3,76.8l1.4,1.3 h-32.8l108.7-108V138.7L218,138.7z M218,53.4v21l-0.5-0.5l-144,143c-7.3-0.3-22.8,1.2-29.3-2.1l172.1-171 C217.5,46.7,218,50,218,53.4z M189.9,25.1c2.9,0,5.6,0.4,8.2,1.2L27.7,195.6c-1.6-4.7-0.6-25.1-0.9-30.4L167.9,25.1 C167.9,25.1,189.9,25.1,189.9,25.1z M132.2,25.1L26.8,129.8V98.5l73.9-73.4L132.2,25.1L132.2,25.1z M26.8,63 C24.3,36.8,38.9,22.5,65,25.1L26.8,63z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.9,52.4h63c45.3,0,76.4,27.3,76.4,69.3S418.2,191,372.9,191h-63V52.4z M371.3,164.7 c27.5,0,45.5-16.4,45.5-43s-18-43-45.5-43H342v85.9L371.3,164.7L371.3,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M473.5,52.4h32.1V191h-32.1V52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M665.5,52.4V191h-26.3l-69.1-84.2V191h-31.7V52.4H565l68.9,84.2V52.4H665.5L665.5,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M689.7,121.7c0-41.2,32.1-71.7,75.8-71.7s75.8,30.3,75.8,71.7s-32.3,71.7-75.8,71.7S689.7,162.9,689.7,121.7z  M808.9,121.7c0-26.3-18.6-44.3-43.4-44.3s-43.4,18-43.4,44.3s18.6,44.3,43.4,44.3S808.9,148,808.9,121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M953.8,191l-26.7-38.6h-29.5V191h-32.1V52.4h60c37,0,60.2,19.2,60.2,50.3c0,20.8-10.5,36-28.5,43.8l31.1,44.6 H953.8L953.8,191z M923.7,78.5h-26.1v48.3h26.1c19.6,0,29.5-9.1,29.5-24.2S943.3,78.5,923.7,78.5L923.7,78.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9e94f594.svg";
export { ForwardRef as ReactComponent };